/**
 * Feature Unavailable Page
 * Displayed when a user tries to access a feature not available for their institution type
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Button, Badge, Alert } from 'react-bootstrap';
import { BsExclamationTriangle, BsHouseDoor } from 'react-icons/bs';
import { selectInstitutionType } from '../../redux/slices/institutionSlice';
import config from '../../config/config';

const FeatureUnavailable = () => {
  const navigate = useNavigate();
  const institutionType = useSelector(selectInstitutionType);

  const handleGoHome = () => {
    navigate(`${config.baseUrl}dashboard`);
  };

  return (
    <Container className="mt-5">
      <Card className="text-center shadow">
        <Card.Body className="p-5">
          <BsExclamationTriangle size={64} className="text-warning mb-4" />
          <h2 className="mb-3">Feature Not Available</h2>
          <p className="text-muted mb-4">
            This feature is not available for your current institution type.
          </p>

          {institutionType && (
            <Alert variant="info" className="mb-4">
              <strong>Current Institution Type:</strong>{' '}
              <Badge bg="primary" className="ms-2">
                {institutionType.replace('_', ' ').toUpperCase()}
              </Badge>
            </Alert>
          )}

          <p className="text-muted mb-4">
            Different institution types have access to different features based on their needs.
            If you believe you should have access to this feature, please contact your system
            administrator.
          </p>

          <Button variant="primary" onClick={handleGoHome}>
            <BsHouseDoor className="me-2" />
            Go to Dashboard
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default FeatureUnavailable;
